





























































































































interface Foreigner {
    country: string;
    entryDate: string | Date;
    departureDate: string | Date;
    birthCountry: string;
    gender: string | null;
    birthday: string | Date;
    declareType: string | null;
    otherLicenseType: string;
    otherLicenseNo: string;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";
import country from "./country";
import idTypeList from "../../data/idTypeList";

@Component({
    ...mapGetters(["account", "accountBook"])
})
export default class Foreigners extends Vue {
    @Prop({ type: Object })
    foreignerInfo!: any;

    @Prop({ type: Boolean })
    isAdd!: boolean;

    @Prop({ type: String })
    newItemLicenseType!: any;

    @Prop() isOther!: boolean;

	typeList: any = []; //选择
    countryList = country; //国家
    otherLicenseType: string = ""
    otherLicenseNo: string = ""
    info: Foreigner = {
        country: "",
        entryDate: "",
        departureDate: "",
        birthCountry: "",
        gender: "0",
        birthday: "",
        declareType: "0",
        otherLicenseType: "",
        otherLicenseNo: "",
    };

    mounted() {
        let input: any = document.querySelector(
            ".foucs-input .el-input__inner"
        );
        if(this.newItemLicenseType) {
            switch (this.newItemLicenseType) {
					case "2":
                        this.typeList = [
                            "中国护照"
                        ]
						break;
                    case "3":
                        this.typeList = [
                            "中华人民共和国港澳居民居住证"
                        ]
						break;
                    case "4":
                        this.typeList = [
                            "中华人民共和国台湾居民居住证"
                        ]
						break;
                    case "7":
                        this.typeList = [
                            "外国人永久居留身份证（外国人永久居留证）",
                            "中华人民共和国外国人工作许可证（A类）",
                            "中华人民共和国外国人工作许可证（B类）",
                            "中华人民共和国外国人工作许可证（C类）",
                            "外国护照",
                        ]
						break;           
				}
        }
        input.focus();
        if (this.foreignerInfo) {
            this.info.country = this.foreignerInfo.country;
            if (this.foreignerInfo.entryDate)
                this.info.entryDate = this.$utils.strToDate(
                    this.foreignerInfo.entryDate
                );
            if (this.foreignerInfo.departureDate)
                this.info.departureDate = this.$utils.strToDate(
                    this.foreignerInfo.departureDate
                );
            this.info.birthCountry = this.foreignerInfo.birthCountry;
            this.info.gender = this.foreignerInfo.gender;
            this.info.declareType = this.foreignerInfo.declareType;
            this.info.otherLicenseNo = this.foreignerInfo.otherLicenseNo
            this.info.otherLicenseType = this.foreignerInfo.otherLicenseType
            if (this.foreignerInfo.birthday)
                this.info.birthday = this.$utils.strToDate(
                    this.foreignerInfo.birthday
                );
        }
    }
    save() {
        let notNull;
        if(this.info.otherLicenseType !=="" && this.info.otherLicenseType !== null) {
            if(this.info.otherLicenseNo === "") {
                this.$message.warning("请填写其他证件号码");
                return
            }
        }
        if(this.info.otherLicenseNo !== "" && this.info.otherLicenseNo !== null) {
            if(this.info.otherLicenseType ==="") {
                this.$message.warning("请填写其他证件类型");
                return
            }
        }
        if (!this.isOther) {
            notNull = this.$utils.notNull([
                this.info.country,
                this.info.entryDate,
                this.info.departureDate,
                this.info.birthCountry,
                this.info.birthday
            ]);
        } else {
            notNull = this.$utils.notNull([
                this.info.country,
                this.info.birthCountry,
                this.info.birthday
            ]);
        }
        if (
            notNull &&
            (this.info.gender === "0" || this.info.gender === "1") &&
            (this.info.declareType === "0" || this.info.declareType === "1")
        ) {
            console.log(
                (this.info.gender === "0" || this.info.gender === "1") &&
                    (this.info.declareType === "0" ||
                        this.info.declareType === "1"),
                "2nd"
            );
            if (this.info.birthday)
                this.info.birthday = this.$utils.simpleDateFormat(
                    <Date>this.info.birthday,
                    "d"
                );
            if (this.info.entryDate)
                this.info.entryDate = this.$utils.simpleDateFormat(
                    <Date>this.info.entryDate,
                    "d"
                );
            if (this.info.departureDate)
                this.info.departureDate = this.$utils.simpleDateFormat(
                    <Date>this.info.departureDate,
                    "d"
                );
            if (this.foreignerInfo && !this.isAdd) {
                this.foreignerInfo.country = this.info.country;
                this.foreignerInfo.entryDate = this.info.entryDate;
                this.foreignerInfo.departureDate = this.info.departureDate;
                this.foreignerInfo.birthCountry = this.info.birthCountry;
                this.foreignerInfo.gender = this.info.gender;
                this.foreignerInfo.declareType = this.info.declareType;
                this.foreignerInfo.birthday = this.info.birthday;
                this.foreignerInfo.otherLicenseType = this.info.otherLicenseType;
                this.foreignerInfo.otherLicenseNo = this.info.otherLicenseNo;
                this.$emit("success", this.foreignerInfo, 1);
            } else this.$emit("success", this.info, 0);
        } else this.$message.warning("请完整填写外籍人员信息!");
    }
    esc() {
        this.$emit("close");
    }
}
